import * as React from 'react';
import { useSuggestKeyboard } from './useSuggestKeyboard';
import { clamp } from '../../../internal/utils';
export function useSuggestSelectedItem(_ref, _ref2) {
  let {
    suggestions,
    open,
    onClose,
    onSelect
  } = _ref;
  let {
    suggestionsChildrenRef,
    listBoxRef
  } = _ref2;
  const [selectedItemIndex, setSelectedItemIndex] = React.useState(undefined);
  React.useEffect(() => setSelectedItemIndex(0), [open]);
  const onEscape = React.useCallback(() => open && (onClose === null || onClose === void 0 ? void 0 : onClose({
    source: 'escapeKey'
  })), [onClose, open]);
  const onEnter = React.useCallback(() => selectedItemIndex !== undefined && suggestions[selectedItemIndex] && open && (onSelect === null || onSelect === void 0 ? void 0 : onSelect(suggestions[selectedItemIndex], {
    source: 'keyboard'
  })), [onSelect, suggestions, selectedItemIndex, open]);
  const onKeyboardSetItem = React.useCallback(actionType => {
    setSelectedItemIndex(previousIndex => {
      var _suggestions$nextInde, _listBoxRef$current;
      const nextIndex = {
        last: suggestions.length - 1,
        first: 0,
        increment: clamp((previousIndex !== null && previousIndex !== void 0 ? previousIndex : 0) + 1, 0, suggestions.length - 1),
        decrement: clamp((previousIndex !== null && previousIndex !== void 0 ? previousIndex : 0) - 1, 0, suggestions.length - 1)
      }[actionType];
      if (((_suggestions$nextInde = suggestions[nextIndex]) === null || _suggestions$nextInde === void 0 ? void 0 : _suggestions$nextInde.type) === 'title') {
        return previousIndex;
      }
      (_listBoxRef$current = listBoxRef.current) === null || _listBoxRef$current === void 0 || (_listBoxRef$current = _listBoxRef$current.children[nextIndex]) === null || _listBoxRef$current === void 0 || _listBoxRef$current.scrollIntoView({
        block: 'nearest'
      });
      return nextIndex;
    });
  }, [listBoxRef, suggestions]);
  useSuggestKeyboard({
    onEnter,
    onEscape,
    onKeyboardSetItem,
    suggestionsChildrenRef,
    listBoxRef
  });
  return {
    suggestionsChildrenRef,
    setSelectedItemIndex,
    selectedItemIndex
  };
}